import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { ASSETS } from "@/lib/assets";

const LINKS = [
  { href: "#pillars", label: "Pillars" },
  { href: "#about", label: "About" },
  { href: "#services", label: "Services" },
  { href: "#contact", label: "Contact" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#0A0A0A]/85 border-b border-[#C9A66B]/25"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 flex items-center justify-between h-16 md:h-20">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
        >
          <img
            src={ASSETS.logoMonogram}
            alt="Becoming H.E.R."
            className="h-10 md:h-12 w-auto rounded-sm border border-[#C9A66B]/30 group-hover:border-[#C9A66B]/70 transition-colors"
          />
          <span className="hidden sm:block font-serif text-[11px] tracking-[0.32em] uppercase text-[#C9A66B] leading-tight">
            Becoming
            <br />
            <span className="text-[#EDEDED]">H.E.R. LLC</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="hover-underline text-[12px] tracking-[0.22em] uppercase text-[#EDEDED] font-medium"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="nav-cta"
          className="hidden md:inline-block bg-[#EDEDED] text-[#0A0A0A] hover:bg-[#C9A66B] hover:text-[#0A0A0A] transition-colors duration-300 px-6 py-3 text-[11px] tracking-[0.22em] uppercase"
        >
          Start a Project
        </a>

        <button
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden p-2 text-[#EDEDED]"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-[#0A0A0A] border-t border-[#2A2A2A] px-6 py-6"
        >
          <div className="flex flex-col gap-5">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`mobile-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setOpen(false)}
                className="text-sm tracking-[0.2em] uppercase text-[#EDEDED]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              data-testid="mobile-cta"
              onClick={() => setOpen(false)}
              className="mt-2 inline-block w-fit bg-[#EDEDED] text-[#0A0A0A] px-6 py-3 text-[11px] tracking-[0.22em] uppercase"
            >
              Start a Project
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
